import {
  DASHBOARD_FETCH_FAILED,
  DASHBOARD_FETCH_REQUESTED,
  DASHBOARD_FETCH_SUCCEEDED,
  NARRATIVE_FETCH_FAILED,
  NARRATIVE_FETCH_REQUESTED,
  NARRATIVE_FETCH_SUCCEEDED,
  NARRATIVE_HISTORY_FETCH_FAILED,
  NARRATIVE_HISTORY_FETCH_REQUESTED,
  NARRATIVE_HISTORY_FETCH_SUCCEEDED,
  NARRATIVE_HISTORY_RESET,
  SET_NARRATIVE,
  TRANSITION_COMPLETED,
  TRANSITION_FAILED,
  TRANSITION_PROPOSED,
  TRANSITION_REQUESTED,
  TRANSITION_SUCCEEDED,
} from '../constants'

const narrativeInitialState = {
  narrative: null,
  narrativeLoading: false,
  proposedTransition: false,
  transitionStatus: null,
  error: null,
  narrativeHistory: [],
  narrativeHistoryLoading: false,
  dashboard: [],
  dashboardLoading: false,
}

export const narrativeReducer = (state = narrativeInitialState, action) => {
  // console.log('narrativeReducer state, action: ', state, action)
  switch (action.type) {
    case TRANSITION_PROPOSED:
      return {
        ...state,
        proposedTransition: action.transition,
        transitionStatus: action.type,
        narrative: action.narrative,
      }
    case TRANSITION_REQUESTED:
      return {
        ...state,
        proposedTransition: action.transition,
        transitionStatus: action.type,
        narrative: action.narrative,
      }
    case TRANSITION_SUCCEEDED:
      return {
        ...state,
        transitionStatus: action.type,
        narrative: action.narrative,
      }
    case TRANSITION_FAILED:
      return {
        ...state,
        transitionStatus: action.type,
        error: action.error,
      }
    case TRANSITION_COMPLETED:
      return {
        ...state,
        transitionStatus: null,
        proposedTransition: false,
        error: null,
      }
    case NARRATIVE_FETCH_REQUESTED:
      return {
        ...state,
        narrativeLoading: true,
      }
    case SET_NARRATIVE:
    case NARRATIVE_FETCH_SUCCEEDED:
      return {
        ...state,
        narrative: action.narrative,
        narrativeLoading: false,
      }
    case NARRATIVE_FETCH_FAILED:
      return {
        ...state,
        narrative: null,
        narrativeLoading: false,
        error: action.error,
      }
    case NARRATIVE_HISTORY_FETCH_REQUESTED:
      return {
        ...state,
        narrativeHistoryLoading: true,
        narrativeHistory: [],
      }
    case NARRATIVE_HISTORY_FETCH_SUCCEEDED:
      return {
        ...state,
        narrativeHistoryLoading: false,
        narrativeHistory: action.narrativeHistory,
      }
    case NARRATIVE_HISTORY_FETCH_FAILED:
      return {
        ...state,
        narrativeHistoryLoading: false,
        narrativeHistory: [],
        error: action.error,
      }
    case NARRATIVE_HISTORY_RESET:
      return {
        ...state,
        narrativeHistoryLoading: false,
        narrativeHistory: [],
      }
    case DASHBOARD_FETCH_REQUESTED:
      return {
        ...state,
        dashboard: [],
        dashboardLoading: true,
      }
    case DASHBOARD_FETCH_SUCCEEDED:
      return {
        ...state,
        dashboard: action.dashboard,
        dashboardLoading: false,
      }
    case DASHBOARD_FETCH_FAILED:
      return {
        ...state,
        error: action.error,
        dashboard: [],
        dashboardLoading: false,
      }
    default:
      return state
  }
}
